/* FUT7 — comportamento do sections/f7-header.liquid (port do tnf-header.js da TNF v8).
   Nomes de equipas e seleções: SEMPRE pelo mapa [data-f7-clubes] (código -> nome; pt usa n, outros ne). O Liquid só escreve o código. */
(function(){
  var root = document.querySelector('[data-f7-nv]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var section = root.closest('.shopify-section') || root.parentNode;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var desk = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LANG = document.documentElement.lang || 'pt-PT';
  var PT = /^pt/i.test(LANG);
  var T = {};
  try { T = JSON.parse(root.parentNode.querySelector('[data-f7-nv-i18n]').textContent) || {}; } catch (e) {}
  var _t = function(k, v){ var s = T[k] || ''; if (v) { for (var x in v) s = s.split('{' + x + '}').join(v[x]); } return s; };

  var MAP = {};
  try {
    var d = document.querySelector('[data-f7-clubes]');
    (d ? JSON.parse(d.textContent) : []).forEach(function(c){ if (c && c.c && !MAP[c.c]) MAP[c.c] = PT ? c.n : (c.ne || c.n); });
  } catch (e) {}
  var nameOf = function(code){ return MAP[code] || ''; };
  var initials = function(n){
    return n.replace(/^(FC|AC|AS|RB|CF|SC|CA|SL)\s+/i, '').split(/[\s-]+/).filter(Boolean).map(function(w){ return w.charAt(0); }).join('').slice(0, 3).toUpperCase();
  };
  var codeFromHandle = function(h){
    var parts = (h || '').split('-');
    for (var i = parts.length - 1; i >= 0; i--) if (/^\d{3}$/.test(parts[i]) && MAP[parts[i]]) return parts[i];
    return '';
  };

  /* 1. Escreve os nomes a partir do código; esconde códigos sem nome no mapa */
  var LINKS = {};
  root.querySelectorAll('[data-f7-nv-club]').forEach(function(a){
    var code = a.dataset.f7NvClub, n = nameOf(code);
    if (!n) { a.hidden = true; return; }
    var s = a.querySelector('[data-f7-nv-cname]'); if (s) s.textContent = n;
    var m = a.querySelector('[data-f7-nv-mono]'); if (m) m.textContent = initials(n);
    a.setAttribute('aria-label', n);
    a.title = n;
    if (!LINKS[code]) { var img = a.querySelector('img'); LINKS[code] = { href: a.getAttribute('href'), img: img ? img.getAttribute('src') : '' }; }
  });
  root.querySelectorAll('[data-f7-nv-sort]').forEach(function(g){
    Array.prototype.slice.call(g.children)
      .sort(function(a, b){ return nameOf(a.dataset.f7NvClub).localeCompare(nameOf(b.dataset.f7NvClub), LANG); })
      .forEach(function(x){ g.appendChild(x); });
  });
  root.querySelectorAll('[data-f7-nv-autosubmit]').forEach(function(sel){
    sel.addEventListener('change', function(){ sel.form.submit(); });
  });

  /* 2. Megamenus do computador: abrem ao passar o rato (com pequena espera) e no clique/teclado */
  var openId = null, tOpen = null, tClose = null;
  var scrim = root.querySelector('[data-f7-nv-scrim]');
  var setScrim = function(on){ scrim.hidden = !on; };
  var closeMega = function(keepScrim){
    if (!openId) return;
    var trig = root.querySelector('[data-f7-nv-mega="' + openId + '"]'), panel = root.querySelector('[data-f7-nv-panel="' + openId + '"]');
    if (panel) panel.hidden = true;
    if (trig) trig.setAttribute('aria-expanded', 'false');
    openId = null;
    if (!keepScrim) setScrim(false);
  };
  var openMega = function(id){
    if (openId === id) return;
    closeMega(true);
    var trig = root.querySelector('[data-f7-nv-mega="' + id + '"]'), panel = root.querySelector('[data-f7-nv-panel="' + id + '"]');
    if (!trig || !panel) return;
    closeSearch(); closeLoc();
    panel.hidden = false; trig.setAttribute('aria-expanded', 'true'); openId = id; setScrim(true);
  };
  root.querySelectorAll('.f7-nv__item.has-mega').forEach(function(li){
    var trig = li.querySelector('[data-f7-nv-mega]'), id = trig.dataset.f7NvMega;
    li.addEventListener('mouseenter', function(){ if (!desk.matches) return; clearTimeout(tClose); tOpen = setTimeout(function(){ openMega(id); }, openId ? 0 : 110); });
    li.addEventListener('mouseleave', function(){ clearTimeout(tOpen); tClose = setTimeout(function(){ if (openId === id) closeMega(); }, 180); });
    trig.addEventListener('click', function(e){
      if (!desk.matches) return;
      if (openId !== id) { e.preventDefault(); openMega(id); }
    });
    trig.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); openMega(id); var f = root.querySelector('[data-f7-nv-panel="' + id + '"] a, [data-f7-nv-panel="' + id + '"] button'); if (f) f.focus(); }
    });
  });

  /* Abas das competições: trocam ao passar o rato ou clicar */
  root.querySelectorAll('[data-f7-nv-tab]').forEach(function(tab){
    var show = function(){
      var box = tab.closest('.f7-nv-comp');
      box.querySelectorAll('[data-f7-nv-tab]').forEach(function(t){ var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
      box.querySelectorAll('[data-f7-nv-pane]').forEach(function(p){ p.hidden = p.dataset.f7NvPane !== tab.dataset.f7NvTab; });
    };
    var t = null;
    tab.addEventListener('mouseenter', function(){ clearTimeout(t); t = setTimeout(show, 70); });
    tab.addEventListener('mouseleave', function(){ clearTimeout(t); });
    tab.addEventListener('click', show);
    tab.addEventListener('focus', show);
  });

  /* 3. País/moeda e idioma */
  var loc = root.querySelector('[data-f7-nv-loc]');
  var closeLoc = function(){ if (!loc) return; loc.querySelector('.f7-nv-loc__pop').hidden = true; loc.querySelector('[data-f7-nv-loc-btn]').setAttribute('aria-expanded', 'false'); };
  if (loc) {
    loc.querySelector('[data-f7-nv-loc-btn]').addEventListener('click', function(e){
      e.stopPropagation();
      var pop = loc.querySelector('.f7-nv-loc__pop'), open = pop.hidden;
      closeMega(); closeSearch();
      pop.hidden = !open; this.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function(e){ if (!loc.contains(e.target)) closeLoc(); });
  }

  /* 4. Busca com sugestões: equipas (pelo mapa) e produtos (nome da equipa pelo código no handle) */
  var sBox = root.querySelector('[data-f7-nv-search]'), sBtn = root.querySelector('[data-f7-nv-search-open]');
  var sIn = root.querySelector('[data-f7-nv-q]'), sClubs = root.querySelector('[data-f7-nv-sclubs]'), sRes = root.querySelector('[data-f7-nv-sres]');
  var esc = function(t){ return String(t).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var norm = function(t){ return String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var openSearch = function(){ closeMega(true); closeLoc(); sBox.classList.remove('is-mq'); sBox.hidden = false; setScrim(true); sBtn.setAttribute('aria-expanded', 'true'); setTimeout(function(){ sIn.focus(); }, 30); };
  function closeSearch(){ if (!sBox || sBox.hidden) return; sBox.hidden = true; sBtn.setAttribute('aria-expanded', 'false'); if (!openId) setScrim(false); }
  sBtn.addEventListener('click', function(){ sBox.hidden ? openSearch() : closeSearch(); });
  root.querySelector('[data-f7-nv-search-close]').addEventListener('click', closeSearch);
  var sTimer = null, sSeq = 0;
  sIn.addEventListener('input', function(){
    clearTimeout(sTimer);
    var q = sIn.value.trim();
    if (q.length < 2) { sClubs.innerHTML = ''; sRes.innerHTML = ''; return; }
    sTimer = setTimeout(function(){ runSearch(q); }, 180);
  });
  var key = function(t){ return norm(t).replace(/[^a-z0-9]+/g, ' ').trim(); };
  var NAMES = {};
  Object.keys(MAP).forEach(function(c){ NAMES[key(MAP[c])] = c; });
  /* Palavras de produto: [variações, palavra no título/handle, tag do filtro da coleção]. Variação mais longa primeiro. */
  var KW = [
    ['home|first|1st|principal|primeira', 'home', 'type-home'],
    ['away|second|2nd|alternativa|segunda', 'away', 'type-away'],
    ['third|3rd|terceira|terceiro', 'third', 'type-third'],
    ['fourth|4th|quarta', 'fourth', 'type-fourth'],
    ['goalkeeper|keeper|gk|guarda redes|guardaredes|goleiro', 'goalkeeper', 'type-goalkeeper'],
    ['retro|vintage|classic|classica|classico', 'retro', 'season-retro'],
    ['tracksuit|fato de treino|fatos de treino', 'tracksuit', 'item-tracksuit'],
    ['training|treino', 'training', 'type-training'],
    ['pre match|prematch|pre jogo', 'pre match', 'type-pre-match'],
    ['special edition|special|edicao especial|especial', 'special', 'type-special'],
    ['kids|kid|youth|junior|crianca|criancas|infantil', 'kids', 'gender-kids'],
    ['womens|women|woman|ladies|mulher|senhora', 'women', 'gender-womens'],
    ['mens|men|homem', 'men', 'gender-mens'],
    ['player edition|player version|player|jogador|authentic', 'player', 'version-player'],
    ['long sleeve|longsleeve|manga comprida', 'long sleeve', 'sleeve-long'],
    ['baby|bebe', 'baby', 'version-baby']
  ];
  var FILLER = /^(shirt|shirts|jersey|jerseys|kit|kits|the|of|fc|cf|camisola|camisolas|camisa|camisas|equipamento|equipamentos|de|da|do)$/;
  var resolve = function(q){
    var t = key(q).split(' ').filter(Boolean), code = '', used = {};
    for (var n = Math.min(4, t.length); n > 0 && !code; n--) {
      for (var i = 0; i + n <= t.length; i++) {
        var p = t.slice(i, i + n).join(' '), c = NAMES[p];
        if (c) { code = c; for (var k = i; k < i + n; k++) used[k] = 1; break; }
      }
    }
    var rest = t.filter(function(w, i){ return !used[i] && !FILLER.test(w); }).join(' '), kws = [];
    KW.forEach(function(k){
      k[0].split('|').some(function(a){
        var re = new RegExp('(^| )' + a + '( |$)');
        if (!re.test(rest)) return false;
        rest = rest.replace(re, ' ').replace(/\s+/g, ' ').trim(); kws.push(k); return true;
      });
    });
    return { code: code, kws: kws, rest: rest };
  };
  var fromColl = function(p){ return { handle: p.handle, title: p.title, url: ROOT + 'products/' + p.handle, img: p.images && p.images[0] ? p.images[0].src : '', price: p.variants && p.variants[0] ? String(parseFloat(p.variants[0].price) * ((window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1)) : '' }; };
  var fromSug = function(p){ return { handle: p.handle, title: p.title, url: p.url, img: p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || ''), price: p.price }; };
  /* Produtos da equipa: a coleção dela (até 100). Na FUT7 a coleção da equipa é /collections/<código>. */
  var CLUB = {};
  var clubProducts = function(code){
    if (CLUB[code]) return CLUB[code];
    var href = LINKS[code] ? LINKS[code].href : ROOT + 'collections/' + code;
    var req = fetch(href + '/products.json?limit=100').then(function(r){ return r.ok ? r.json() : null; }).then(function(d){ return ((d && d.products) || []).map(fromColl); });
    return (CLUB[code] = req.catch(function(){ delete CLUB[code]; return []; }));
  };
  var pick = function(ps, R){
    var has = function(p, w){ return (' ' + key(p.title) + ' ').indexOf(' ' + w + ' ') > -1 || (' ' + key(p.handle || '') + ' ').indexOf(' ' + w + ' ') > -1; };
    var out = ps.filter(function(p){ return R.kws.every(function(k){ return has(p, k[1]); }); });
    if (R.rest) {
      var w = out.filter(function(p){ return R.rest.split(' ').every(function(x){ return has(p, x); }); });
      if (w.length) out = w;
    }
    return out;
  };
  /* Para onde vai "ver tudo"/Enter: a coleção da equipa, já filtrada pelo tipo quando há produto dele */
  var clubHref = function(code){ return LINKS[code] ? LINKS[code].href : ROOT + 'collections/' + code; };
  var target = function(R, q, found){
    if (!R.code) return ROOT + 'search?type=product&q=' + encodeURIComponent(q);
    var h = clubHref(R.code);
    if (!R.kws.length || !found.length) return h;
    return h + '/' + R.kws.map(function(k){ return k[2]; }).join('+');
  };
  var fmtPrice = function(p){
    var n = parseFloat(p); if (isNaN(n)) return '';
    try { return new Intl.NumberFormat(LANG, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(n); } catch (e) { return n.toFixed(2); }
  };
  var runSearch = function(q){
    var nq = norm(q), seq = ++sSeq, R = resolve(q);
    var hits = Object.keys(MAP).filter(function(c){ return norm(nameOf(c)).indexOf(nq) > -1 && (LINKS[c] || /^\d{3}$/.test(c)); });
    if (R.code) hits = [R.code].concat(hits.filter(function(c){ return c !== R.code; }));
    hits = hits.filter(function(c){ return LINKS[c]; }).slice(0, 8);
    sClubs.innerHTML = hits.map(function(c){
      var L = LINKS[c], n = nameOf(c);
      return '<a class="f7-nv-club" href="' + esc(L.href) + '"><span class="f7-nv-crest">' + (L.img ? '<img src="' + esc(L.img) + '" alt="" width="30" height="30">' : '<i>' + esc(initials(n)) + '</i>') + '</span><span class="f7-nv-club__name">' + esc(n) + '</span></a>';
    }).join('');
    var codeHit = R.code || (hits.length && norm(nameOf(hits[0])).indexOf(nq) === 0 ? hits[0] : '');
    var allHref = ROOT + 'search?type=product&q=' + encodeURIComponent(q);
    var req = codeHit
      ? clubProducts(codeHit).then(function(all){
          var RR = R.code ? R : { code: codeHit, kws: [], rest: '' };
          var found = pick(all, RR);
          allHref = target(RR, q, found);
          return (found.length ? found : all).slice(0, 7);
        })
      : fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=hide', { headers: { Accept: 'application/json' } })
          .then(function(r){ return r.ok ? r.json() : null; }).then(function(d){ return ((d && d.resources && d.resources.results && d.resources.results.products) || []).map(fromSug); });
    req.then(function(ps){
      if (seq !== sSeq) return;
      var html = ps.map(function(p){
        var club = nameOf(codeFromHandle(p.handle)), title = (club && p.title.indexOf(club) === -1 ? club + ' ' : '') + p.title;
        var img = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=140' : '';
        return '<a class="f7-nv-sres" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '<span><b>' + esc(title) + '</b><span>' + esc(p.price ? fmtPrice(p.price) : '') + '</span></span></a>';
      }).join('');
      if (ps.length) html += '<a class="f7-nv-sres f7-nv-sres--all" href="' + esc(allHref) + '">' + esc(_t('see_all')) + '</a>';
      else if (!hits.length) html = '<p class="f7-nv-sres f7-nv-sres--none">' + esc(_t('no_results')) + '</p>';
      sRes.innerHTML = html;
    }).catch(function(){});
  };
  /* Enter na busca do cabeçalho: equipa reconhecida vai direto para a coleção dela (com o filtro do tipo pedido).
     Texto sem equipa segue para a busca normal (o f7-busca do layout continua como rede de segurança). */
  root.addEventListener('submit', function(e){
    var f = e.target, inp = f && f.querySelector && f.querySelector('input[name="q"]');
    if (!inp) return;
    var q = inp.value.trim(), R = resolve(q);
    if (!R.code) return;
    e.preventDefault(); e.stopPropagation();
    var done = false, go = function(u){ if (done) return; done = true; location.href = u; };
    var t = setTimeout(function(){ go(clubHref(R.code)); }, 2500);
    clubProducts(R.code).then(function(all){ clearTimeout(t); go(target(R, q, pick(all, R))); });
  }, true);

  /* 4b. Busca sempre aberta no telemóvel: escreve exemplos no campo (nomes pelo mapa) e usa as mesmas sugestões */
  var mqOn = false;
  var mq = root.querySelector('[data-f7-nv-mq]');
  if (mq) {
    var mIn = mq.querySelector('[data-f7-nv-mq-in]'), mPh = mq.querySelector('[data-f7-nv-mq-ph]');
    var base = mPh.textContent.trim();
    var words = [base].concat((mq.dataset.examples || '').split(',').map(function(c){ return nameOf(c.trim()); }).filter(Boolean).map(function(n){ return _t('search_club', { name: n }); }));
    var wi = 0, ci = base.length, del = true, tT = null;
    var tick = function(){
      var w = words[wi];
      ci += del ? -1 : 1;
      mPh.textContent = w.slice(0, ci);
      if (!del && ci >= w.length) { del = true; tT = setTimeout(tick, 1900); return; }
      if (del && ci <= 0) { del = false; wi = (wi + 1) % words.length; tT = setTimeout(tick, 320); return; }
      tT = setTimeout(tick, del ? 26 : 62);
    };
    var startType = function(){
      clearTimeout(tT);
      if (reduce || words.length < 2) { mPh.textContent = base; return; }
      wi = 0; ci = base.length; del = true; mPh.textContent = base;
      tT = setTimeout(tick, 2600);
    };
    var hideRes = function(){ sBox.hidden = true; sClubs.innerHTML = ''; sRes.innerHTML = ''; };
    var mqClose = function(){
      if (!mqOn) return;
      mqOn = false; mIn.value = ''; mIn.blur(); mq.classList.remove('is-on');
      hideRes(); if (!openId) setScrim(false); startType();
    };
    mIn.addEventListener('focus', function(){
      if (mqOn) return;
      mqOn = true; clearTimeout(tT); mq.classList.add('is-on');
      closeLoc(); setScrim(true); section.classList.remove('is-hidden');
    });
    var mTimer = null;
    mIn.addEventListener('input', function(){
      clearTimeout(mTimer);
      var q = mIn.value.trim();
      if (q.length < 2) { hideRes(); return; }
      mTimer = setTimeout(function(){ sBox.classList.add('is-mq'); sBox.hidden = false; runSearch(q); }, 180);
    });
    mq.querySelector('[data-f7-nv-mq-x]').addEventListener('click', mqClose);
    scrim.addEventListener('click', mqClose);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') mqClose(); });
    window.addEventListener('pageshow', function(e){ if (e.persisted) { mqOn = true; mqClose(); } });
    startType();
  }

  /* 5. Gaveta do telemóvel em painéis */
  var drawer = root.querySelector('[data-f7-nv-drawer]'), burger = root.querySelector('[data-f7-nv-open]');
  var stack = ['root'];
  var panel = function(id){ return drawer.querySelector('[data-f7-nv-dpanel="' + id + '"]'); };
  var showPanel = function(from, id, back){
    var cur = panel(from), nxt = panel(id);
    if (!nxt || !cur || cur === nxt) return;
    if (back) { cur.classList.remove('is-on'); nxt.classList.remove('is-back'); nxt.classList.add('is-on'); }
    else { cur.classList.add('is-back'); cur.classList.remove('is-on'); nxt.classList.add('is-on'); }
    nxt.scrollTop = 0;
  };
  var openDrawer = function(){
    drawer.hidden = false; drawer.classList.remove('is-closing'); section.style.zIndex = '2100';
    document.documentElement.classList.add('f7-nv-lock'); burger.setAttribute('aria-expanded', 'true'); setScrim(true);
    section.classList.remove('is-hidden');
  };
  var closeDrawer = function(){
    if (drawer.hidden) return;
    var done = function(){
      drawer.hidden = true; drawer.classList.remove('is-closing');
      drawer.querySelectorAll('.f7-nv-drawer__panel').forEach(function(p){ p.classList.remove('is-on', 'is-back'); });
      panel('root').classList.add('is-on'); stack = ['root'];
      section.style.zIndex = '';
    };
    document.documentElement.classList.remove('f7-nv-lock'); burger.setAttribute('aria-expanded', 'false'); setScrim(false);
    if (reduce) return done();
    drawer.classList.add('is-closing'); setTimeout(done, 260);
  };
  burger.addEventListener('click', openDrawer);
  drawer.addEventListener('click', function(e){
    var go = e.target.closest('[data-f7-nv-go]');
    if (go) { showPanel(stack[stack.length - 1], go.dataset.f7NvGo); stack.push(go.dataset.f7NvGo); return; }
    if (e.target.closest('[data-f7-nv-back]') && stack.length > 1) { var from = stack.pop(); showPanel(from, stack[stack.length - 1], true); return; }
    if (e.target.closest('[data-f7-nv-close]')) closeDrawer();
  });
  scrim.addEventListener('click', function(){ closeMega(); closeSearch(); closeDrawer(); });
  if (desk.addEventListener) desk.addEventListener('change', function(){ if (desk.matches) closeDrawer(); else closeMega(); });

  /* v9: o menu tem de caber entre o logótipo e os ícones. Mede a soma dos itens (o menu está centrado, por isso o
     scrollWidth não mostra o que sai pela esquerda). Não cabe -> is-tight; nem assim -> is-burger (menu ☰). */
  var navBox = root.querySelector('.f7-nv__nav'), menuUl = root.querySelector('.f7-nv__menu'), fitT;
  var need = function(){
    var w = 0, kids = menuUl.children;
    for (var i = 0; i < kids.length; i++) w += kids[i].getBoundingClientRect().width;
    return w + Math.max(0, kids.length - 1) * (parseFloat(getComputedStyle(menuUl).columnGap) || 0);
  };
  var fit = function(){
    if (!navBox || !menuUl) return;
    root.classList.remove('is-tight', 'is-burger');
    if (!desk.matches) return;
    if (need() <= navBox.clientWidth + 1) return;
    root.classList.add('is-tight');
    if (need() > navBox.clientWidth + 1) { closeMega(); root.classList.add('is-burger'); }
  };
  fit();
  window.addEventListener('resize', function(){ clearTimeout(fitT); fitT = setTimeout(fit, 120); });
  if (desk.addEventListener) desk.addEventListener('change', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  window.addEventListener('load', fit);

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    if (openId) { var t = root.querySelector('[data-f7-nv-mega="' + openId + '"]'); closeMega(); if (t) t.focus(); }
    closeSearch(); closeLoc(); closeDrawer();
  });

  /* 6. Cesto: abre a Upcart quando existe; o contador relê o /cart.js nos eventos da Upcart e do tema */
  var cartLink = root.querySelector('[data-f7-nv-cart]'), countEl = root.querySelector('[data-f7-nv-count]');
  cartLink.addEventListener('click', function(e){
    if (typeof window.upcartOpenCart === 'function') { e.preventDefault(); window.upcartOpenCart(); }
  });
  var setCount = function(n){
    var prev = parseInt(countEl.textContent, 10) || 0;
    countEl.textContent = n; countEl.hidden = !n;
    if (n > prev && !reduce) { countEl.classList.remove('is-bump'); void countEl.offsetWidth; countEl.classList.add('is-bump'); }
  };
  var cSeq = 0;
  var refreshCount = function(){
    var my = ++cSeq;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(c){ if (my === cSeq) setCount(c.item_count || 0); }).catch(function(){});
  };
  ['cart:refresh', 'cart:updated', 'upcart:cart:updated'].forEach(function(ev){ document.addEventListener(ev, refreshCount); });
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) refreshCount(); });
  var tries = 0;
  (function hook(){
    if (typeof window.upcartSubscribeCartUpdated !== 'function') { if (++tries < 40) setTimeout(hook, 500); return; }
    ['upcartSubscribeCartUpdated', 'upcartSubscribeAddedToCart', 'upcartSubscribeItemRemoved'].forEach(function(n){
      try { if (typeof window[n] === 'function') window[n](function(){ refreshCount(); }); } catch (e) {}
    });
  })();

  /* 7. O cabeçalho some ao rolar para baixo e volta ao rolar para cima */
  var lastY = window.scrollY, ticking = false;
  var onScroll = function(){
    ticking = false;
    var y = window.scrollY, busy = openId || mqOn || !sBox.hidden || !drawer.hidden;
    if (!busy) section.classList.toggle('is-hidden', y > lastY && y > 240);
    section.classList.toggle('is-scrolled', y > 8);
    lastY = y;
  };
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  document.documentElement.style.setProperty('--f7-nv-h', root.offsetHeight + 'px');

  /* 8. A barra do app (store-app-bar) também cola no topo: o cabeçalho cola logo abaixo dela */
  var appbar = document.querySelector('[id$="__store-app-bar"]');
  var setTop = function(){
    var h = 0;
    if (appbar && getComputedStyle(appbar).position === 'sticky') h = appbar.getBoundingClientRect().height;
    section.style.top = h + 'px';
  };
  setTop();
  if (appbar && window.ResizeObserver) new ResizeObserver(setTop).observe(appbar);
})();
